import { useState } from "react";
import { Edit } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SubjectConditionEditPanel } from "./SubjectConditionEditPanel";

interface SubjectConditionSummaryProps {
  type: 'subject_includes_words' | 'subject_matches_patterns';
  value: string[];
  onChange: (value: string[]) => void;
}

export function SubjectConditionSummary({ type, value, onChange }: SubjectConditionSummaryProps) {
  const [isEditPanelOpen, setIsEditPanelOpen] = useState(false);

  const getConditionText = () => {
    if (!value || value.length === 0) {
      return type === 'subject_includes_words' 
        ? "No words specified" 
        : "No patterns specified";
    }

    const items = value.slice(0, 3).map(item => `'${item}'`).join(' or ');
    const remaining = value.length > 3 ? ` and ${value.length - 3} more` : '';
    
    if (type === 'subject_includes_words') {
      return `The subject contains any of these words ${items}${remaining}`;
    } else {
      return `The subject matches these text patterns ${items}${remaining}`;
    }
  };

  return (
    <>
      <div className="flex items-center justify-between p-3 bg-muted/50 rounded-md">
        <span className="text-sm text-foreground">{getConditionText()}</span>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setIsEditPanelOpen(true)}
          className="h-6 w-6 p-0"
        >
          <Edit className="h-3 w-3" />
        </Button>
      </div>
      
      <SubjectConditionEditPanel
        isOpen={isEditPanelOpen}
        onClose={() => setIsEditPanelOpen(false)}
        type={type}
        value={value}
        onChange={onChange}
      />
    </>
  );
}